import React from "react"
import InsightsCardHeading from "../InsightsCardHeading"
import { CardWrapper } from "../../../../../Cards/base"

const InsightsCard_v2020: React.FC<{
  value: number
  cutoff: number
  heading: string
}> = ({ value, cutoff, heading }) => {
  let scoreComment = (
    <div>
      <h1 className="text-2xl text-site-blue mb-2">Higher risk</h1>
      <div className="w-12 h-1 rounded-full bg-site-blue mb-4" />
      <p>
        When seeking to identify women who are at higher risk for developing GDM and
        for participation in a clinical trial we recommend that
        you consider this person.
      </p>
    </div>
  )
  if (value < cutoff) {
    scoreComment = (
      <div>
        <h1 className="text-2xl text-site-blue mb-2">Low risk</h1>
        <div className="w-12 h-1 rounded-full bg-site-blue mb-4" />
        <p>
          On average, this person has a lower than average risk of developing GDM.
        </p>
      </div>
    )
  }
  return (
    <CardWrapper className="hover:shadow-none">
      <InsightsCardHeading heading={heading} enable={true} />
      <div className="flex items-center justify-center h-full">
        <div className="py-5 px-5 text-site-blue">{scoreComment}</div>
      </div>
    </CardWrapper>
  )
}

export default InsightsCard_v2020
